import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithErrorHandling } from './baseQuery';

interface Progress {
  done: number;
  total: number;
}

export const caseContextProgressApi = createApi({
  reducerPath: 'caseContextProgressApi',
  baseQuery: baseQueryWithErrorHandling,
  tagTypes: ['CaseContextProgress'] as const,
  endpoints: (builder) => ({
    getProgress: builder.query<Progress, string>({
      query: (matterId) => `api/matters/${matterId}/case-context-progress/`,
      providesTags: (_r, _e, matterId) => [
        { type: 'CaseContextProgress', id: matterId },
      ],
    }),
  }),
});

export const { useGetProgressQuery: useGetCaseContextProgressQuery } =
  caseContextProgressApi;
